import { updateDataOfBlock } from './index'
import * as api from 'api'
import { 
    EditorState, 
    Modifier 
} from 'draft-js';
import { 
    addNewBlock, 
    getCurrentBlock, 
    addEmptyBlock, 
    addNewBlockAt 
} from './index';
import { fileValidation } from 'utils'

export const onPasteText = (text, html, editorState, setEditorState, onPopper, dispatch, user) => {
    const currentBlock = getCurrentBlock(editorState)
    const blockType = currentBlock.getType()

    if(blockType === 'code-block'){
        const contentState = editorState.getCurrentContent()
        const selection = editorState.getSelection()

        let newState
        let newContentState
        if (!selection.isCollapsed()) {
            newContentState = Modifier.replaceText(
                contentState,
                selection,
                text
            )
        } else {
            newContentState = Modifier.insertText(
                contentState,
                selection,
                text
            )
        }
        newState = EditorState.push(
            editorState,
            newContentState,
            'insert-characters'
        );
        setEditorState(newState)

        return true
    } 
    return false
}

export const onPasteFile = (file, editorState, setEditorState, onPopper, dispatch, user) => {
    const fileType = file ? file.type.split('/')[0] : null;
    const validation = fileValidation(file) // Default validation is img
    if(validation.valid){
        // Create new image block with loader
        let newState = addNewBlock(editorState, 'IMAGE', {wait: true})
        const imgBlock = getCurrentBlock(newState)
        newState = addEmptyBlock(newState)
        setEditorState(newState)

        // Upload file
        const formData = new FormData();
        formData.append("file", file);
        formData.append("fileName", `${user['uid']}_${new Date().getTime()}`);
        formData.append("userId", user['uid'])
        formData.append("type", "profile_image")

        api.uploadImg(formData)
        .then(uploadRes => {
            const link = uploadRes.data['link']
            newState = updateDataOfBlock(newState,imgBlock, {wait: false, src: link})
            setEditorState(newState)
            console.log('Image uploaded', link)
        })
        .catch(uploadErr => {
            console.log('[uploadImg] Failed', uploadErr)
        })
        
    }
}